module.exports = __webpack_public_path__ + "img/nav-children-line.e5d1b08b.svg";